import {
  InstallmentStatus,
  MerchantGetInvoiceResponse,
  MerchantInvoice,
} from '@types'
import { transformLineItemInstallment } from 'services/transformers/bill.transform'

function manageGetMerchantInvoiceData(
  response: MerchantGetInvoiceResponse
): MerchantInvoice {
  let hasChanged = false

  const invoice_installments = response.invoice.invoice_installments.map(
    (installment) => {
      function handleCurrentInstallmentStatus() {
        if (installment.status === InstallmentStatus.Pending && !hasChanged) {
          installment.status = InstallmentStatus.Current
          hasChanged = true
        }
      }

      installment.status = translateStatus(
        installment.buyer_conciliation_status
      )

      handleCurrentInstallmentStatus()

      return installment
    }
  )

  const lineItemsUpdated = response.line_items.map((lineItem) => {
    return transformLineItemInstallment(lineItem)
  })

  return {
    ...response.invoice,
    invoice_installments,
    line_items: lineItemsUpdated,
    nfe_download_token: response.nfe_download_token,
  }
}

export function managerGetMerchantInvoiceTransform(
  response: MerchantGetInvoiceResponse
): MerchantInvoice {
  return manageGetMerchantInvoiceData(response)
}

function translateStatus(
  status: InstallmentStatus | 'fully-settled'
): InstallmentStatus {
  return status === InstallmentStatus.FullySettled
    ? InstallmentStatus.Settled
    : status
}

export function getDisplayableID(
  short_id: string,
  external_id?: string
): string {
  return external_id || short_id
}
